import {
  type DefaultQueryError,
  type UploadOrderImageRequest,
  type UploadOrderImageResponse,
  uploadOrderImageFn,
  apiRoutes,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

const useUploadOrderImage = (
  opts?: Omit<
    UseMutationOptions<
      UploadOrderImageResponse,
      DefaultQueryError,
      UploadOrderImageRequest,
      unknown
    >,
    'mutationKey'
  >
): ReturnType<typeof useMutation> =>
  useMutation<
    UploadOrderImageResponse,
    DefaultQueryError,
    UploadOrderImageRequest
  >({
    mutationKey: [apiRoutes.assets.upload_order_image],
    mutationFn: uploadOrderImageFn,
    ...opts,
  });

export default useUploadOrderImage;
